
export enum UniformVariantType {
    Base, Variant1, Variant2, Variant3
}